export default{
    /**
     * set url per channel
     * @param {*} channel 
     */
     getChanelUrl(channel){
        var params = {};
        var url = (channel.MainUrl!="" && channel.MainUrl!=null)?channel.MainUrl:channel.SecondaryUrl;
        var accountKey = window.dgAccountKey;
        switch (channel["Channel"].Id) {
            case 1:
                if(channel.LoadActio=="iframe"){
                    params ={secondaryUrl:channel["SecondaryUrl"]};
                }
                break;
            case 3:
                params ={targetUrl: btoa(document.location.origin),accountKey:accountKey};
        }
        if(Object.keys(params).length>0){url = this.setUrlParams(url,params);}

        return url;
    },
    /**
     * Add parameters to url from object
     * @param {*} uri 
     * @param {*} paramsObj 
     * @returns 
     */
    setUrlParams(uri, paramsObj) {
        Object.keys(paramsObj).forEach(function (key) {
          var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
          var separator = uri.indexOf('?') !== -1 ? "&" : "?";
          if (uri.match(re)) {
            uri = uri.replace(re, '$1' + key + "=" + paramsObj[key] + '$2');
          }
          else {
              uri += separator + key + "=" + paramsObj[key];
          }
        });
        
        return uri;
    }
}